import { ChangeDetectionStrategy, Component, Input, SimpleChanges } from '@angular/core';
import { Product } from '../product.decorator';
import { DfImageDirective } from '@df/module-image/df-image.directive';

/**
 * Displays product price
 */
@Component({
    selector: 'product-image-label',
    templateUrl: './product-image-label.html',
    styleUrls: ['./product-image-label.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [DfImageDirective]
})
export class ProductImageLabelComponent {
    /**
     * Default image
     */
    @Input({
        required: true
    })
    product!: Product;

    /**
     * Image to display
     */
    protected image?: string;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['product']) {
            this.image = this.product.labelImage;
        }
    }
}
